import React from 'react';
import { Button } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import { faExclamation, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Moment from 'react-moment';

export default class roleEventsLi extends React.Component {
  constructor(props) {
    super(props);
    this.renderData = this.renderData.bind(this);
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  renderData(event, index, isDeadLinePassed, props, role) {
    const {Pending, Executed, EventLabel, Deadline, Enabled, EventDataType, Type, ID, Ancestors} = event;
    const {onClick, isDisable, showModal, isMultiSimulationAllow, isSelectedRole} = props;
    return <Card.Text key={index}>
      {Pending === 'true' && <FontAwesomeIcon className='pending' icon={faExclamation} />}
      {Pending === 'false' && Executed === 'true' && <FontAwesomeIcon className='executed' icon={faCheck} />} {EventLabel}
      {((Deadline != null)) ?
        isDeadLinePassed == false ?
          <label className='itemDeadline label label-info'>
            <Moment locale="de" format="L LT">{Deadline}</Moment>
          </label>
          :
          <label className='itemDeadline label label-error'>
            <Moment locale="de" format="L LT">{Deadline}</Moment>
          </label>
        :
        ''
      }
        {(Enabled === "true" && (EventDataType === '' && Type === 0)) ? <Button value={index} variant="success" className="float-right" size="sm" onClick={() => onClick(ID, role, true, null)} disabled={isDisable}>{(isMultiSimulationAllow & !isSelectedRole) ? 'Other' : 'Execute'}</Button>
        :
        ''
      }
        {(Enabled === "true" && (EventDataType !== '' || Type === 3)) ? <Button value={index} variant="success" className="float-right" size="sm" onClick={() => showModal(true, ID, role, (EventDataType !== '' && Ancestors === '' ? true : false))} disabled={isDisable}>Open</Button>
        :
        ''
      }
    </Card.Text>

  }

  render() {
    let eventsData;
    let self = this;
    let events = [];
    const role = self.props.role;
    const props = self.props;
    const isDeadLinePassed = props.isDeadLinePassed;
    if (props.events != null) {
      if (props.events.length === undefined) {
        events.push(props.events)
      }
      else {
        events = props.events;
      }
    }
    if (events.length > 0) {
      eventsData = events.map(function (event, index) {
        return (
          event.Events === null ?
            <Card key={index} className="borderZero marginBottom10">
              {self.renderData(event, index, isDeadLinePassed, props, role)}
            </Card>
            :
            <Card key={index} className="borderZero marginBottom10">
              {self.renderData(event, index, isDeadLinePassed, props, role)}
              {
                <div className='margin-left-30'>
                  {
                    event.Events.map(function (events, index) {
                      return self.renderData(events, index, isDeadLinePassed, props, role)
                    })
                  }
                </div>
              }
            </Card>
        )
      });
    }
    else {
      eventsData = <div />
    }

    return (
      <div>
        {eventsData}
      </div>
    );
  }
}